import React, { Component } from 'react';
import { Row, Col, Table, PanelGroup, Panel } from "react-bootstrap";
import DatePicker from 'react-date-picker';
import Switch from "react-switch";
import Select from 'react-select';
import { toast } from 'react-toastify';
import QRCode from 'qrcode.react';

import { CustomCard } from "../../../components/Card/CustomCard";
import CustomModal from "../../../components/Modal/CustomModal";

import { ConsultaDeudaEst, ConsultCuentaAdmin, ConsultaNumCuenta, PagarInd } from "../../../funciones/EstCuentaFunction";
import { ConsultVerificacionesInd, ConsultMetodos, ConsultCambio } from '../../../funciones/AdministracionFunction';
import { ConsultCitados, ConsultAllCitados, ConsultDetalles, consultaRequisitos, NoAdmitir, Admitir,
        BusquedaEstAdm, CambiaFechaAdm } from "../../../funciones/AdmisionFunction";
import { CheckStatusDelT } from "../../../funciones/CobranzasFunction";
import { formatNumber, formatReconver } from "../../../funciones/GeneralFunctions";

import VerificacionPagoTable from "../../Administracion/EstadosCuentaContent/VerificacionPagoTable";
import CambiaFecha from './CambiaFecha';

import ModalReports from '../../../components/Reportes/ModalReports';
import AdmisionCitados from '../../../components/Reportes/AdmisionCitados';

let idDetalle = "";
let IdUser = "";
let CuentaPay = 0;
let errores = 0;
let fecha = new Date();
let UserState = "";

class Consignacion extends Component {
    state = {
        cantCitados: 0,
        preloader: "fa fa-spinner fa-spin",
        citados: [],
        string: {
            text: "Selecciona un aspirante citado para revisar",
            icon: ""
        },
        strings: "",
        icon2: "",
        textCitados: {
            icon: "fa fa-spinner fa-spin",
            text: "Buscando aspirantes citados"
        },
        textCitadosHoy: "Aspirantes Citados para Hoy",
        disabled: false,
        datosDetalle: "",
        perfil: true,
        iconChevron1: "fa fa-chevron-down",
        btnDown1: true,
        documentos: true,
        iconChevron2: "fa fa-chevron-down",
        btnDown2: true,
        iconChevron3: "fa fa-chevron-down",
        btnDown3: true,
        estados: true,
        requisitos: [],
        preloader2: <React.Fragment><i className="fa fa-spinner fa-spin"></i> Buscando lista de requisitos</React.Fragment>,
        observaciones: "",
        boton1:{
            text: "Aprobar",
            icon: "fa fa-check"
        },
        boton2:{
            text: "No Aprobar",
            icon: "fa fa-times"
        },
        boton4:{
            text: "Registrar Pago",
            icon: "fa fa-money"
        },
        modalNoAcceptBtn1: {
            icon:"fa fa-check",
            text: "Si",
            disabled: false
        },
        
        motivo : {
            text:"",
            mensaje: ""
        },
        openNoAccept: false,
        openAccept: false,
        openPago: false,
        modalAcceptBtn1: {
            icon:"fa fa-check",
            text: "Si",
            disabled: false
        },
        modalPagoBtn1: {
            icon:"fa fa-money",
            text: "Registrar",
            disabled: false
        },
        asientos: [],
        verificaciones: [],
        metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
        metodos: [],
        deudaT: "",
        fecha: fecha,
        otroMonto: "",
        total: true,
        otro: false,
        concepto: "",
        cambio: "",
        divisas: "",
        bsCambio: 0,
        selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
        cuentas: [],
        num: "",
        factura: "",
        openWR: false,
        btnFull: { icon: "fa fa-plus", text: "Ver Todo", disabled: false },
        openCFecha: false,
        modalFechaBtn1: {
            icon:"fa fa-calendar-plus-o",
            text: "Cambiar",
            disabled: false
        },
        fechaO: "",
        status: ""
    }

    /* constructor (props) {
        super (props);

        
    } */

    componentWillUnmount = () => {
        idDetalle = "";
    }

    componentDidMount = () => {
        idDetalle = "";

        CheckStatusDelT ((resp) => {
            UserState = resp
            this.setState({ status: resp })
        })

        ConsultCitados ((resp) => {
            if (resp.length === 0) {
                this.setState({
                    textCitados: {
                        icon: "",
                        text: "No tienes estudiantes citados para el dia de hoy"
                    },
                    citados: resp,
                    cantCitados: resp.length,
                    preloader: ""
                })
            }else{
                this.setState({
                    citados: resp,
                    cantCitados: resp.length,
                    preloader: ""
                })
            }
        })

        ConsultMetodos ((resp) => {
            this.setState({
                metodos: resp
            })
        })

        ConsultCambio ((resp) => {
            this.setState({
                cambio: resp
            })
        })

        ConsultaNumCuenta ((resp) => {
            this.setState({
                nuCuenta: resp[0],
                cuentas: resp[1]
            })
        })
    }

    busquedaEst = () => (e) => {
        idDetalle = "";
        if (e.which === 13){
            this.setState ({
                icon2: "fa fa-spinner fa-spin",
                textCitados: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Buscando aspirantes"
                },
                citados: [],
                cantCitados: 0,
            }, () => {
                BusquedaEstAdm (this.state.strings, (resp) => {
                    if (resp.length === 0) {
                        this.setState({
                            icon2: "",
                            textCitados: {
                                icon: "",
                                text: "No tienes aspirantes que coincidan con la búsqueda"
                            },
                            citados: resp,
                            cantCitados: resp.length,
                            preloader: ""
                        })
                    }else{
                        this.setState({
                            icon2: "",
                            citados: resp,
                            cantCitados: resp.length,
                            preloader: ""
                        })
                    }
                })
            })
        }
    }

    cambiaIcon = (btn, icon, content) => {
        this.setState ({
            [btn]: !this.state[btn],
            [content]:!this.state[content],
            openNoAccept: false,
            openAccept: false,
            openPago: false,
        }, () => {
            (this.state[btn] === true) ? this.setState({[icon]: "fa fa-chevron-down"}) : this.setState({[icon]: "fa fa-chevron-up"})
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase(),
            openNoAccept: false,
            openAccept: false,
            openPago: false,
        });
    };

    cambiaValorM = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase(),
            openNoAccept: false,
            openAccept: false,
        });
    };

    cambiaValorDivisa = () => (event) => {
        if (!isNaN(Number(event.target.value)) === false) return null;
        let valorCambio = parseInt(this.state.cambio) * parseInt(event.target.value)
        if (event.target.value === "") valorCambio = 0;
        this.setState({
            divisas: event.target.value,
            openNoAccept: false,
            openAccept: false,
            bsCambio: valorCambio
        });
    };

    cambiaValor2 = (prop) => (event) => {
        this.setState({
            [prop]: {
                text: (event.target.value).toUpperCase(),
                mensaje: ""
            }
        });
    };

    cambiaFecha = (date) => {
        this.setState({
            fecha: date
        });
    }

    valorMetodo = (metodoSelect) => {
        this.setState({
            metodoSelect
        });
    }

    valorCuenta = (selectcuenta) => {
        this.setState({
            selectcuenta
        });
    }

    pagar = (prop) => {
        this.setState({
            total: false,
            otro: false,
        }, () => { 
            this.setState({[prop]: true})
        })
    }

    verTodo = () => (e) => {
        if (this.state.btnFull.disabled === true) return null
        
        this.setState({
            btnFull: {icon: "fa fa-spinner fa-spin", text: "Buscando", disabled: true},
            textCitados: { icon: "fa fa-spinner fa-spin", text: "Buscando Estudiantes" }
        }, () => {
            ConsultAllCitados ((resp) => {
                if (resp.length === 0) {
                    this.setState({
                        textCitados: {
                            icon: "",
                            text: "No tienes estudiantes en este listado"
                        },
                        textCitadosHoy: "Todos los Aspirantes",
                        citados: resp,
                        cantCitados: resp.length,
                        preloader: "",
                        btnFull: {icon: "fa fa-plus", text: "Ver Todo", disabled: false}
                    })
                }else{
                    this.setState({
                        citados: resp,
                        cantCitados: resp.length,
                        preloader: "",
                        btnFull: {icon: "fa fa-plus", text: "Ver Todo", disabled: false},
                        textCitadosHoy: "Todos los Aspirantes",
                    })
                }
            })
        })
 
    }

    verModalNoAccept = () => (e) => {
        this.setState({
            openNoAccept: true,
            openAccept: false,
            openPago: false,
            motivo : {
                text:"",
                mensaje: ""
            }
        })
    }

    verModalAccept = () => (e) => {
        this.setState({
            openNoAccept: false,
            openAccept: true,
            openPago: false,
        })
    }

    modalAccept = () => {

        const { openAccept, modalAcceptBtn1, observaciones } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>¿Desea realmente <strong className="text-primary">APROBAR</strong> la solicitud de este Aspirante?</div>
                <div style={{fontSize: 12, padding: 5}} className="custom-alert-danger" align="center"><i className="fa fa-exclamation-triangle"></i> <strong>Recuerda revisar primero el pago de los aranceles antes de aceptar la solicitud</strong></div>
            </React.Fragment>
        )

        let Aceptar = (id) => (e) => {
            if (this.state.modalAcceptBtn1.disabled === true) return null;

            this.setState({
                modalAcceptBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            })

            Admitir (id, observaciones,  () => {
                this.setState ({
                    openAccept: false,
                    motivo : {
                        text:"",
                        mensaje: ""
                    },
                },() => {
                    idDetalle = "";
                    toast.info("Has aceptado correctamente la solicitud del aspirante",{autoClose: 4000});
                    ConsultCitados ((resp) => {
                        if (resp.length === 0) {
                            this.setState({
                                textCitados: {
                                    icon: "",
                                    text: "No tienes estudiantes citados para el dia de hoy"
                                },
                                citados: resp,
                                cantCitados: resp.length,
                                preloader: "",
                                modalAcceptBtn1: {
                                    icon:"fa fa-check",
                                    text: "Si",
                                    disabled: false
                                },
                            })
                        }else{
                            this.setState({
                                citados: resp,
                                cantCitados: resp.length,
                                preloader: "",
                                modalAcceptBtn1: {
                                    icon:"fa fa-check",
                                    text: "Si",
                                    disabled: false
                                },
                            })
                        }
                    }) 
                });
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalAcceptBtn1.icon}></i> {modalAcceptBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openAccept}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {Aceptar(IdUser)}
                funcion2 = {() => {this.setState({openAccept: false})}}
            />
        );
    }

    modalNoAccept = () => {

        const { openNoAccept, modalNoAcceptBtn1, motivo } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>¿Desea realmente <strong className="text-danger"> NO APROBAR</strong> la solicitud de este Aspirante?</div>
                
                <div className="custom-alert-danger" style={{padding:5}}>
                    <input type="text" value={motivo.text} onChange={this.cambiaValor2("motivo")} className="form-control" placeholder="Indica el motivo"/>
                    <span className="text-danger" style={{fontSize: 12}}>{motivo.mensaje}</span>
                </div>
            </React.Fragment>
        )

        let noAceptar = (id) => (e) => {
            if (this.state.modalNoAcceptBtn1.disabled === true) return null;

            if ((motivo.text) === "") {
                this.setState({
                    motivo : {
                        text:"",
                        mensaje: "Indica primero el motivo",
                    }
                })
                return null;
            }

            this.setState({
                modalNoAcceptBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            })

            NoAdmitir (id, motivo.text, (resp) => {
                this.setState ({
                    openNoAccept: false,
                    motivo : {
                        text:"",
                        mensaje: ""
                    }
                },() => {
                    idDetalle = "";
                    toast.info("Has eliminado correctamente la solicitud del aspirante",{autoClose: 4000});
                    ConsultCitados ((resp) => {
                        if (resp.length === 0) {
                            this.setState({
                                textCitados: {
                                    icon: "",
                                    text: "No tienes estudiantes citados para el dia de hoy"
                                },
                                citados: resp,
                                cantCitados: resp.length,
                                preloader: "",
                                modalNoAcceptBtn1: {
                                    icon:"fa fa-check",
                                    text: "Si",
                                    disabled: false
                                },
                            })
                        }else{
                            this.setState({
                                citados: resp,
                                cantCitados: resp.length,
                                preloader: "",
                                modalNoAcceptBtn1: {
                                    icon:"fa fa-check",
                                    text: "Si",
                                    disabled: false
                                },
                            })
                        }
                    }) 
                });
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalNoAcceptBtn1.icon}></i> {modalNoAcceptBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openNoAccept}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {noAceptar(IdUser)}
                funcion2 = {() => {this.setState({openNoAccept: false})}}
            />
        );
    }

    modalPago = () => {
        const { openPago, modalPagoBtn1, metodoSelect, metodos, total, otro, otroMonto, deudaT, concepto, fecha,
            cambio, divisas, bsCambio, selectcuenta, cuentas, num, factura, observaciones } = this.state;

        let campos = {metodoSelect, divisas, bsCambio, num, fecha, deudaT, otroMonto, total, otro, concepto, selectcuenta,
            observaciones, factura};

        const styles = {
            padding: 2, fontSize: 12
        }

        let montoPayEf = () => (
            <div className="table-responsive">
                <Table bordered style={{marginBottom: 0}}>
                    <tbody>
                        <tr>
                            <td width= "50px" style={styles}>
                                <Switch height={12} width={24} onChange={() => {this.pagar("total")}} checked={total} />
                            </td>
                            <td width= "100%" style={styles}>
                                <input type="text" maxLength= {10} value={deudaT.totalGral} disabled className="form-control" placeholder="Ej.: 35000"/>
                                <div className="text-muted" style={{fontSize: 9}}>Monto Total</div>
                            </td>
                        </tr>
                        <tr>
                            <td width= "50px" style={styles}>
                                <Switch height={12} width={24} onChange={() => {this.pagar("otro")}} checked={otro} />
                            </td>
                            <td width= "100%" style={styles}>
                                <input type="text" maxLength= {10} value={otroMonto} onFocus={() => {this.setState({ total: false, otro: true })}} onChange={this.cambiaValorM("otroMonto")} className="form-control" placeholder="Ej.: 35000"/>
                                <div className="text-muted" style={{fontSize: 9}}>Otro Monto</div>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        )

        let montoDivisa = () => (
            <React.Fragment>
                <input type="text" maxLength= {10} value={deudaT.totalGral} disabled className="form-control" placeholder="Ej.: 35000"/>
                <div className="text-muted" style={{fontSize: 9}}>Monto Total</div>
                <Row>
                    <Col md={5}>
                        <input type="text" maxLength= {4} onChange ={this.cambiaValorDivisa()} value={divisas} className="form-control" placeholder="Ej.: 50"/>
                        <div className="text-muted" style={{fontSize: 9}}>Monto en Divisas ($)</div>  
                    </Col>
                    <Col md={7}>
                        <input type="text" maxLength= {50} disabled value={bsCambio} className="form-control"/>
                        <div className="text-muted" style={{fontSize: 9}}>Equivalencia en Bs.</div>
                    </Col>
                </Row>
                <div className="text-danger" style={{fontSize: 10, marginTop: 5}}>Cambio del dia: <strong>{cambio} Bs por Dólar</strong></div>
            </React.Fragment>
        )

        let conceptoEf = () => (
            <React.Fragment>
                <Col md={12}>
                    <textarea maxLength= {100} onChange={this.cambiaValorM("concepto")} className="form-control" placeholder="Ej.: PAGO DE MENSUALIDAD" value={concepto}></textarea>
                </Col>
                <Col md={12} className="custom-mt-10">
                    <DatePicker
                        clearIcon= {<i className="fa fa-times"></i>}
                        calendarIcon= {<i className="fa fa-calendar"></i>}
                        className="form-control"
                        onChange={this.cambiaFecha}
                        value={fecha}
                    />
                    <div className="text-muted" style={{fontSize: 9}}>(*) Fecha del pago</div>
                </Col>
            </React.Fragment>
        )

        let contenidoGral = () => (
            <React.Fragment>
                <Col md={6} className="custom-mt-10">
                    <input maxLength= {20} type="text" value={num} onChange={this.cambiaValorM("num")} className="form-control" placeholder="Ej.: 001828212828"/>
                    <div className="text-muted" style={{fontSize: 9}}>(*) N° de Referencia</div>
                </Col>
                <Col md={6} className="custom-mt-10">
                    <DatePicker
                        clearIcon= {<i className="fa fa-times"></i>}
                        calendarIcon= {<i className="fa fa-calendar"></i>}
                        className="form-control"
                        onChange={this.cambiaFecha}
                        value={fecha}
                    />
                    <div className="text-muted" style={{fontSize: 9}}>(*) Fecha del pago</div>
                </Col>
                <Col md={6} className="custom-mt-10 text-danger">(*) Monto:</Col>
                <Col md={6} className="custom-mt-10 text-danger">Concepto:</Col>
                <Col md={6}>
                    <div className="table-responsive">
                        <Table bordered style={{marginBottom: 0}}>
                            <tbody>
                                <tr>
                                    <td width= "50px" style={styles}>
                                        <Switch height={12} width={24} onChange={() => {this.pagar("total")}} checked={total} />
                                    </td>
                                    <td width= "100%" style={styles}>
                                        <input type="text" maxLength= {10} value={deudaT.totalGral} disabled className="form-control" placeholder="Ej.: 35000"/>
                                        <div className="text-muted" style={{fontSize: 9}}>Monto Total</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td width= "50px" style={styles}>
                                        <Switch height={12} width={24} onChange={() => {this.pagar("otro")}} checked={otro} />
                                    </td>
                                    <td width= "100%" style={styles}>
                                        <input type="text" maxLength= {10} value={otroMonto} onFocus={() => {this.setState({ total: false, otro: true })}} onChange={this.cambiaValorM("otroMonto")} className="form-control" placeholder="Ej.: 35000"/>
                                        <div className="text-muted" style={{fontSize: 9}}>Otro Monto</div>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </Col>
                <Col md={6}>
                    <textarea maxLength= {100} onChange={this.cambiaValorM("concepto")} rows={5} className="form-control" placeholder="Ej.: PAGO DE MENSUALIDAD" value={concepto}></textarea>
                </Col>
            </React.Fragment>
        )

        let contentPay = () => {
            switch (metodoSelect.label) {
                case "EFECTIVO":
                    return(
                        <Row>
                            <Col md={6} className="text-danger">(*) Monto:</Col>
                            <Col md={6} className="text-danger">Concepto:</Col>
                            <Col md={6}>
                                {montoPayEf()}
                            </Col>
                            <Col md={6}>
                                {conceptoEf()}
                            </Col>
                        </Row>
                    )
                case "DIVISA":
                    return(
                        <Row> 
                            <Col md={6} className="text-danger">(*) Monto:</Col>
                            <Col md={6} className="text-danger">Concepto:</Col>
                            <Col md={6}>
                                {montoDivisa()}
                            </Col>
                            <Col md={6}>
                                {conceptoEf()}
                            </Col>
                        </Row>
                    )
                case "TRANSFERENCIA":
                    return(
                        <Row>
                            <Col md={12}>
                                <Select
                                    isSearchable ={true}
                                    value={selectcuenta}
                                    onChange={this.valorCuenta}
                                    options={cuentas}
                                />
                                <div className="text-muted" style={{fontSize: 9}}>(*) Seleccciona el número de cuenta al cual hiciste la transferencia</div>
                            </Col>
                            {contenidoGral()}
                        </Row>
                    )
                case "DEBITO":
                    return(
                        <Row>
                            {contenidoGral()}
                        </Row>
                    )
                case "CREDITO":
                    return(
                        <Row>
                            {contenidoGral()}
                        </Row>
                    )
                default: return (
                    <div className="text-danger" align="center">Selecciona un Método de Pago</div>
                )
            }
        }

        let contenidoModal = () => (
            <React.Fragment>
                <Row>
                    <Col md={6}>
                        <Select
                            isSearchable ={true}
                            value={metodoSelect}
                            onChange={this.valorMetodo}
                            options={metodos}
                        />
                        <div className="text-muted" style={{fontSize: 9}}>Selecciona un Método de Pago</div>
                    </Col>
                    <Col md={6}>
                        <input type="text" value={factura} onChange={this.cambiaValorM("factura")} className="form-control" placeholder="N° de Factura"/>
                        <div className="text-danger" style={{fontSize: 9}}>Número de la Factura</div>
                    </Col>
                </Row>
                <div className="custom-mt-10">{contentPay()}</div>
            </React.Fragment>
        )

        let pagar = () => {
            if (this.state.modalPagoBtn1.disabled === true) return null
            if (metodoSelect.value === "") {
                toast.error("Debes elegir un método de pago",{autoClose: 4000});
                return null;
            }

            this.setState({
                modalPagoBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text:"Espera",
                    disabled: true
                }
            }, () => {
                PagarInd (IdUser, "Admision", campos, 0,(resp) => {
                    if (resp[0] === "Error"){
                        this.setState({
                            modalPagoBtn1: {
                                icon:"fa fa-check",
                                text:"Registrar",
                                disabled: false
                            }  
                        })
                    }else{
                        if (resp[3] === true) idDetalle = "";

                        this.setState({
                            openNoAccept: false,
                            openAccept: false,
                            openPago: false,
                            otroMonto: "",
                            total: true,
                            otro: false,
                            concepto: "",
                            divisas: "",
                            selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
                            metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
                            num: ""
                        }, () => {
                            ConsultCitados ((resp) => {
                                if (resp.length === 0) {
                                    this.setState({
                                        textCitados: {
                                            icon: "",
                                            text: "No tienes estudiantes citados para el dia de hoy"
                                        },
                                        citados: resp,
                                        cantCitados: resp.length,
                                        preloader: "",
                                        modalPagoBtn1: {
                                            icon:"fa fa-money",
                                            text: "Registrar",
                                            disabled: false
                                        },
                                    })
                                }else{
                                    this.setState({
                                        citados: resp,
                                        cantCitados: resp.length,
                                        preloader: "",
                                        modalPagoBtn1: {
                                            icon:"fa fa-money",
                                            text: "Registrar",
                                            disabled: false
                                        },
                                    })
                                }
                            })
                            ConsultaDeudaEst (IdUser, (resp) => {
                                errores = resp.errores;
                                this.setState({deudaT: resp})
                            })
                            ConsultVerificacionesInd (IdUser, (resp)=> {
                                this.setState({verificaciones: resp,})
                            })
                            ConsultCuentaAdmin (IdUser, (resp)=> {
                                this.setState({asientos: resp})
                            })
                        });
                    }
                    toast[resp[2]](resp[1],{autoClose: 4000});
                })
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalPagoBtn1.icon}></i> {modalPagoBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openPago}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Registrar Pago de Aranceles</div>}
                contenido = {contenidoModal()}      
                funcion1 = {pagar}
                funcion2 = {() => {this.setState({openPago: false})}}
            />
        );
    }

    modalFecha = () => {
        let {openCFecha, modalFechaBtn1, datosDetalle, fechaO} = this.state;

        if (datosDetalle === "") return null;

        let contenidoModal = () => (
            <CambiaFecha fechaI = {datosDetalle.datos.fecha_cita} fechaO= {(date) => {this.setState({fechaO: date})}}
                         clear = {() => {this.setState({fechaO: ""})}}/>
        )

        let cambiar = () => {
            if (modalFechaBtn1.disabled === true || IdUser === "") return null;

            if (fechaO === ""){
                toast.error("Debes seleccionar una fecha",{autoClose: 4000});
                return null;
            }
            
            this.setState({
                modalFechaBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            }, () => {
                CambiaFechaAdm(IdUser, fechaO, (resp) => {
                    toast[resp.status](resp.mess,{autoClose: 4000});
                    idDetalle = "";
                    IdUser = "";
                    this.setState({
                        openCFecha: false,
                        modalFechaBtn1: {
                            icon:"fa fa-calendar-plus-o",
                            text: "Cambiar",
                            disabled: false
                        },
                        fechaO: ""
                    })
                });
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> Cancelar</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalFechaBtn1.icon}></i> {modalFechaBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openCFecha}
                titulo = {<div className="text-primary" style={{fontSize: 14}}>Cambiar fecha de Admisión</div>}
                contenido = {contenidoModal()}      
                funcion1 = {cambiar}
                funcion2 = {() => {this.setState({openCFecha: false})}}
            />
        )
    }

    modalReporte = () => {
        let { openWR, citados } = this.state;
        if (openWR === false ) return null;

        return (
            <ModalReports
                reporte={<AdmisionCitados datos = {citados} />}
                titulo={`Listado de Aspirantes Citados`}
                display= "block"
                cerrar = {() => {this.setState({openWR: false})}}
            />
        )
    }

    ayuda = () => (
        <Row>
            <Col md={12} align="justify">
                En este módulo verás una lista de aspirantes a un cupo que han completado correctamente la solicitud y están citados para el dia de hoy
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                También puedes ver todo el listado de aspitante presionando el botón <button className="btn btn-xs btn-relleno-danger" style={{borderWidth: 1}}><i className="fa fa-plus"></i> Ver Todo</button>
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Selecciona un aspirante de la lista y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-check"></i> Revisar</button>
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Paso 2:</strong>
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Luego de presionar el el botón podrás ver los detalles de la solicitud, los datos personales y los documentos consignados.
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong>Documentos Consignados:</strong>
            </Col>
            <Col md={2} className="custom-mt-10" align="center">
                <i className="fa fa-circle-o"></i>
            </Col>
            <Col md={10} className="custom-mt-10" align="justify">
                Este ícono indica que el aspirante no lo eligió como documento disponible. (Si es un documento necesario agrégalo en el apartado de <strong>Observaciones</strong>)
            </Col>
            <Col md={2} className="custom-mt-10" align="center">
                <i className="fa fa-check-circle text-success"></i>
            </Col>
            <Col md={10} className="custom-mt-10" align="justify">
                Este ícono indica que el aspirante lo eligió como documento disponible y debe tenerlo al momento de la consignación. (Si no posee el documento es necesario agregarlo el apartado de <strong>Observaciones</strong>)
            </Col>
            <Col md={12} className="custom-mt-10">
                <strong style={{color:"#1f2f6e"}}>Paso 3:</strong>
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                Una vez revisado la documentación tienes dos opciones disponibles:
            </Col>
            <Col md={4} className="custom-mt-10" align="center">
                <button className="btn btn-primary btn-xs" style={{borderWidth: 1}}><i className="fa fa-check"></i> Aceptar</button>
            </Col>
            <Col md={8} className="custom-mt-10" align="justify">
                Permite Aceptar la admisión del estudiante
            </Col>
            <Col md={4} className="custom-mt-10" align="center">
                <button className="btn btn-danger btn-xs" style={{borderWidth: 1}}><i className="fa fa-times"></i> No Aceptar</button>
            </Col>
            <Col md={8} className="custom-mt-10" align="justify">
                Esta opción elimina la solicitud de admisión del aspirante y le envía un correo de notificación
            </Col>
            <Col md={4} className="custom-mt-10" align="center">
                <button className="btn btn-warning btn-xs" style={{borderWidth: 1}}>Registrar Pago</button>
            </Col>
            <Col md={8} className="custom-mt-10" align="justify">
                Esta opción permite agregar el pago en cualquier modalidad <strong className="text-primary">(Nota: Es importante revisar el pago de los aranceles antes de aceptar la admisión)</strong>
            </Col>
            <Col md={12} className="custom-mt-10" align="justify">
                <strong>Nota: Todas las solicitudes que no lleguen al momento de la cita serán rechazadas automáticamente</strong>
            </Col>
        </Row>
    )

    revisar = (id, idEst) => {
        idDetalle = "";
        IdUser = idEst;
        this.setState({
            string: {
                text: "Buscando los detalles de esta solicitud",
                icon: "fa fa-spinner fa-spin"
            },
            disabled: false
        }, () => {
            ConsultDetalles (id, (resp)=> {
                idDetalle = id,
                CuentaPay = resp[1]
                this.setState({
                    string: {
                        text: "",
                        icon: ""
                    },
                    datosDetalle: resp[0]
                })
            })

            ConsultCuentaAdmin (idEst, (resp)=> {
                this.setState({asientos: resp})
            })

            ConsultVerificacionesInd (idEst, (resp)=> {
                this.setState({verificaciones: resp,})
            })

            ConsultaDeudaEst (idEst, (resp) => {
                errores = resp.errores;
                this.setState({deudaT: resp})
            })

            consultaRequisitos ((resp)=> {
                if (resp.length === 0) {
                    this.setState({ preloader2: "No existen requisitos registrados" })
                }else{
                    this.setState({ requisitos: resp })
                }
            })
        })
    }

    nombre = (nom1, nom2, ape1, ape2) => {
        if (nom2 === null) nom2 = "";
        if (ape2 === null) ape2 = "";
        return `${nom1} ${nom2} ${ape1} ${ape2}`
    }


    lisCitados = () => {
        let { textCitados, citados, disabled } = this.state;

        if (citados.length === 0) return (
            <tr>
                <td colSpan={4} align="center"><i className={textCitados.icon}></i> {textCitados.text}</td>
            </tr>
        )

        const styles = { padding: 5, fontSize: 12 }
        return (
            citados.map (option => (
                <tr key = {option.id}>
                    <td style={styles}>{`${option.nacionalidad} ${option.ci}`}</td>
                    <td style={styles}>{this.nombre(option.nombre_1, option.nombre_2, option.apellido_1, option.apellido_2)}</td>
                    <td align="center" style={styles}>{option.carrera_name}</td>
                    <td align="center" style={styles}>
                        <button disabled={disabled} className="btn btn-primary" onClick={() => { this.revisar(option.id, option.id_est) }} style={{borderWidth: 1}} title="Revisar los documentos de este aspirante"><i className="fa fa-check"></i> Revisar</button>
                    </td>
                </tr>
            ))
        )
    }

    fechaNac = (fecha) => {
        let hoy = new Date(fecha);
        let dd = hoy.getDate();
        let mm = hoy.getMonth()+1;
        let yyyy = hoy.getFullYear();
        if(dd < 10) dd= '0' + dd;
        if(mm < 10) mm= '0' + mm;
        return `${dd}/${mm}/${yyyy}`
    }

    contenido = () => {
        let { datosDetalle, perfil, iconChevron1, documentos, iconChevron2, iconChevron3, estados, requisitos,
            preloader2, observaciones, boton1, boton2, boton4 } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        if (idDetalle === "") return null;

        let mes = (num) => {
            let meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMPBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"]
            return meses[num - 1]
        }

        let listrequisitos = () => {
            if (requisitos.length === 0) return (
                <tr>
                    <td align="center" colSpan={2}>{preloader2}</td>
                </tr>
            )

            let docConsig = datosDetalle.datos.documentos;
            
            let consig = (doc) => {
                let texto = <i className="fa fa-circle-o"></i>;
                if (docConsig.includes(doc) === true) texto = <i className="fa fa-check-circle text-success"></i>
                return texto
            }

            return(requisitos.map(option => (
                <tr key ={option.id}>
                    <td align="center" style={styles}>
                        {consig(option.id)}
                    </td>
                    <td align="justify" style={{padding: 5, fontSize: 10}}>{option.requisito_desc}</td>
                </tr>  
            )))
        }

        let doc = () => {

            return(
                <React.Fragment>
                    <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowY:"auto", maxHeight: "65vh", overflowX:"hidden"}}>
                        <Table striped hover bordered>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td align="center" width="90px" style={styles}></td>
                                    <td align="center" width="100%" style={styles}><strong>Documentos</strong></td>
                                </tr>
                                {listrequisitos()}
                            </tbody>
                        </Table>
                    </div>
                </React.Fragment>
            )
        }

        let EstadoCuenta = () => {
            const { asientos, verificaciones } = this.state;

            const styles = {
                padding: 5, fontSize: 12
            }

            const stylesBs = {
                padding: 3, fontSize: 10
            }

            let contentEstado = () => {
                let bs = (monto) => {
                    let bs = `${formatNumber(monto)}`;
                    let bsConv = `${formatReconver(monto)}`;

                    if (monto === "" || monto === null) bs = "";
                    return (
                        <React.Fragment>
                            <div>{bs}</div>
                            {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{bsConv}</div> */}
                        </React.Fragment>
                    )
                }

                let icono = (mess, status) => {
                    let icono = <i className="fa fa-check-circle text-success"></i>;
                    if (status === "0") icono = <i className="fa fa-exclamation-triangle text-warning"></i>;
                    if (mess === "Error") icono = <i className="fa fa-times-circle text-danger"></i>;

                    return icono;
                }

                let status = (mess, status) => {
                    let styles = {color:"#000"}
                    if (status === "0") styles = {backgroundColor: "#f8f2ee", color:"#a80012", cursor:"pointer"}
                    if (mess === "Error") styles = {backgroundColor: "#fff4f6", color:"#A0555C", cursor:"pointer"}

                    return styles;
                }

                let aviso = (mess, status) => {
                    let aviso = "";
                    if (status === "0") aviso = "Esta transacción está pendiente de aprobación";
                    if (mess === "Error") aviso = "Esta transacción presenta un problema. Ponte en contacto con Administración";

                    return aviso;
                }

                return (
                    asientos.map(option => (
                        <tr key = {option.num} style={status(option.resultado, option.status)} title ={aviso(option.resultado, option.status)}>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.num}</td>
                            <td align="center" style={{padding: 5, fontSize: 10}}>{option.fecha}</td>
                            <td style={{padding: 5, fontSize: 10}}>{option.descripcion}</td>
                            <td align="center" style={stylesBs}>{bs(option.debe)}</td>
                            <td align="center" style={stylesBs}>{bs(option.haber)}</td>
                            <td align="center" style={stylesBs}>
                                {formatNumber(option.saldo)}
                                {/* <div className = "text-danger" style = {{fontWeight: "bold"}}>{formatReconver(option.saldo)}</div> */}
                            </td>
                            <td align="center" style={styles}>{icono(option.resultado, option.status)}</td>
                        </tr>
                    ))
                )
            }

            let pagos = () => (
                verificaciones.map(option => (
                    <VerificacionPagoTable key={option.id} datos={option} updList = {() => {
                        this.setState({
                            openNoAccept: false,
                            openAccept: false,
                            openPago: false,
                        }, () => {
                            ConsultVerificacionesInd (IdUser, (resp)=> {
                                this.setState({verificaciones: resp,})
                            })
                            ConsultCuentaAdmin (IdUser, (resp)=> {
                                this.setState({asientos: resp})
                            })
                            ConsultaDeudaEst (IdUser, (resp) => {
                                errores = resp.errores;
                                this.setState({deudaT: resp})
                            })
                        })
                    }}/>
                ))
            )
            
            let pays = () => {
                if (CuentaPay === 0) return null;

                return(
                    <div className="custom-alert-info custom-mt-10" style={{padding: 2}}>
                        <div className="table-responsive custom-mt-10" style={{backgroundColor:"#FFF", overflowY:"auto", maxHeight: "30vh", overflowX:"hidden"}}>
                            <Table striped hover bordered style={{marginBottom: 0}}>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width="40%" style={styles}><strong>Estudiante</strong></td>
                                        <td width="60%%" style={styles}><strong>Detalles del Pago</strong></td>
                                        <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                    </tr>
                                    {pagos()}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                )
            }

            return (
                <React.Fragment>
                    <div className="table-responsive" style={{overflowY: "auto", maxHeight:"30vh", backgroundColor: "#FFF", border: "1px solid #1f2f6e"}}>
                        <Table striped hover bordered style={{marginBottom: 0}}>
                            <tbody>
                                <tr className="custon-back-color">
                                    <td width="10%" align="center"style={styles}><strong>N°</strong></td>
                                    <td width="10%" align="center"style={styles}><strong>Fecha</strong></td>
                                    <td width="40%" style={styles}><strong>Descripción</strong></td>
                                    <td width="12%" align="center" style={stylesBs}><strong>Facturado Bs.</strong></td>
                                    <td width="12%" align="center" style={stylesBs}><strong>Pagado Bs.</strong></td>
                                    <td width="16%" align="center" style={stylesBs}><strong>Balance Bs.</strong></td>
                                    <td width="30px" align="center" style={styles}></td>
                                </tr>
                                {contentEstado()}
                            </tbody>
                        </Table>
                    </div>
                    {pays()}
                </React.Fragment>
            )

        }

        let cambiaCita = () => {
            if (UserState !== 1) return null;

            return (
                <div className="custom-alert-danger">
                    <Row>
                        <Col md={9} style={{paddingTop: 5}}><strong>Fecha de la cita: </strong>{datosDetalle.datos.fecha_cita}</Col>
                        <Col md={3} align = "right">
                            <button className="btn btn-relleno-danger btn-sm" onClick = {() => {this.setState({openCFecha:true})}} style={{borderWidth: 1}}><i className="fa fa-calendar"></i> Cambiar</button>
                        </Col>
                    </Row>
                </div>
            )
        }

        if (datosDetalle.datos === undefined) {
            return null
        }else{
            return (
                <React.Fragment>
                    <Row>
                        <Col md={12}>
                            <div className="custom-alert-info">
                                Detalles de la Solicitud
                            </div>
                        </Col>
                        <Col md={9} className="custom-mt-10" style={{paddingTop: 3}}>
                            <div><strong>Carrera: </strong>{datosDetalle.datos.carrera_name}</div>
                            <div><strong>Periodo Académico: </strong>{`${mes(datosDetalle.datos.corte_name)} - ${datosDetalle.datos.corte_year}`}</div>
                            <div><strong>Fecha de la solicitud: </strong>{datosDetalle.datos.fecha_solicitud}</div>
                        </Col>
                        <Col md={3} className="custom-mt-10" align="right">
                            <QRCode renderAs="svg" width={70} height= {70} xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/validar_admision?code=${(datosDetalle.datos.token).substring(0,10)}`}/>
                        </Col>
                        <Col md={12} className="custom-mt-10">
                            {cambiaCita()}
                        </Col>
                        <Col md={12} className="custom-mt-10">
                            <PanelGroup accordion activeKey={perfil} className="custom-alert-info">
                                <Panel eventKey = {true}>
                                    <Panel.Heading  onClick = {()=> {this.cambiaIcon( "btnDown1", "iconChevron1", "perfil")}}>
                                        <Panel.Title toggle className="custom-color">
                                            <Row>
                                                <Col md={10} style={{fontSize: 12}}>
                                                    Ver los Datos Personales
                                                </Col>
                                                <Col md={2} align="right">
                                                    <i className={iconChevron1}></i>
                                                </Col>
                                            </Row>
                                        </Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                                        <div className="custom-alert-info">Datos Personales</div>
                                        <Row style={{padding: 8, color: "#000"}}>
                                            <Col md = {12}>
                                                <strong>Cédula de Identidad: </strong> {`${datosDetalle.datos.nacionalidad} - ${datosDetalle.datos.ci}`}
                                            </Col>
                                            <Col md = {12}>
                                                <strong>Nombres y Apellidos: </strong> {this.nombre(datosDetalle.datos.nombre_1, datosDetalle.datos.nombre_2, datosDetalle.datos.apellido_1, datosDetalle.datos.apellido_2)}
                                            </Col>
                                        </Row>
                                        <div className="custom-alert-info custom-mt-10">Datos de Nacimiento</div>
                                        <Row style={{padding: 8, color: "#000"}}>
                                            <Col md = {6}>
                                                <strong>País: </strong>{datosDetalle.pais}
                                            </Col>
                                            <Col md = {6}>
                                                <strong>Estado: </strong>{datosDetalle.estado}
                                            </Col><Col md = {6}>
                                                <strong>Municipio: </strong>{datosDetalle.municipio}
                                            </Col>
                                            <Col md = {6}>
                                                <strong>Parroquia: </strong>{datosDetalle.parriquia}
                                            </Col>
                                            <Col md = {12}>
                                                <strong>Fecha de Nacimiento: </strong>{this.fechaNac(datosDetalle.datos.f_nac)}
                                            </Col>
                                        </Row>
                                        <div className="custom-alert-info custom-mt-10">Dirección de Habitación</div>
                                        <Row style={{padding: 8, color: "#000"}}>
                                            <Col md = {6}>
                                                <strong>Municipio: </strong>{datosDetalle.municipioDir}
                                            </Col>
                                            <Col md = {6}>
                                                <strong>Parroquia: </strong>{datosDetalle.parriquiaDir}
                                            </Col>
                                            <Col md = {12}>
                                                <strong>Av/Calle/Sector: </strong>{datosDetalle.datos.dir_avenida}
                                            </Col>
                                            <Col md = {12}>
                                                <strong>Edf/Casa/Quinta: </strong>{datosDetalle.datos.dir_casa}
                                            </Col>
                                        </Row>
                                    </Panel.Body>
                                </Panel>
                            </PanelGroup>
                        </Col>
                        <Col md={12}>
                            <PanelGroup accordion activeKey={documentos} className="custom-alert-info">
                                <Panel eventKey = {true}>
                                    <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown2", "iconChevron2", "documentos")}}>
                                        <Panel.Title toggle className="custom-color">
                                            <Row>
                                                <Col md={10} style={{fontSize: 12}}>
                                                    Documentos Consignados
                                                </Col>
                                                <Col md={2} align="right">
                                                    <i className={iconChevron2}></i>
                                                </Col>
                                            </Row>
                                        </Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                                        {doc()}
                                    </Panel.Body>
                                </Panel>
                            </PanelGroup>
                        </Col>
                        <Col md={12}>
                            <PanelGroup accordion activeKey={estados} className="custom-alert-info">
                                <Panel eventKey = {true}>
                                    <Panel.Heading onClick = {()=> {this.cambiaIcon( "btnDown3", "iconChevron3", "estados")}}>
                                        <Panel.Title toggle className="custom-color">
                                            <Row>
                                                <Col md={10} style={{fontSize: 12}}>
                                                    Estado de Cuenta
                                                </Col>
                                                <Col md={2} align="right">
                                                    <i className={iconChevron3}></i>
                                                </Col>
                                            </Row>
                                        </Panel.Title>
                                    </Panel.Heading>
                                    <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                                        {EstadoCuenta()}
                                    </Panel.Body>
                                </Panel>
                            </PanelGroup>
                        </Col>
                        
                        <Col md = {12} className="custom-mt-10">
                            <textarea title="Agrega aquí las observaciones respecto a este aspirante" placeholder="Observaciones" onChange={this.cambiaValor("observaciones")} value={observaciones} className="form-control"></textarea>
                        </Col>
                        <Col md = {12} className="custom-mt-10" align="right">
                            <div className="btn-group" style={{marginRight: 5}}>
                                <button className="btn btn-warning" onClick = {
                                    () => {
                                        this.setState({
                                            openNoAccept: false,
                                            openAccept: false,
                                            openPago: true,
                                            otroMonto: "",
                                            total: true,
                                            otro: false,
                                            concepto: "",
                                            divisas: "",
                                            selectcuenta: { value: '', label: ' - Selecciona una Cuenta - ' },
                                            metodoSelect: { value: '', label: ' - Selecciona un Método - ' },
                                            num: "",
                                            modalPagoBtn1: {
                                                icon:"fa fa-money",
                                                text: "Registrar"
                                            },
                                            total: true,
                                            bsCambio: 0,
                                            factura: ""
                                        })
                                    }} 
                                title="Registrar pago" style={{borderWidth: 1}}><i className={boton4.icon}></i> {boton4.text}</button>
                            </div>
                            <div className="btn-group">
                                <button className="btn btn-primary" onClick = {this.verModalAccept()} style={{borderWidth: 1}}><i className={boton1.icon}></i> {boton1.text}</button>
                                <button className="btn btn-danger" onClick = {this.verModalNoAccept()} style={{borderWidth: 1}}><i className={boton2.icon}></i> {boton2.text}</button>
                            </div>
                        </Col>
                    </Row>
                </React.Fragment>
            )
        }
    }

    render() {
        const { cantCitados, preloader, string, strings, icon2, btnFull, textCitadosHoy } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div className="custom-alert-info" style={{padding: 5}}>
                            <Row>
                                <Col md={5}>
                                    <div style={{marginTop: 10}}><i className="fa fa-clone"></i> {textCitadosHoy} <strong>({cantCitados})</strong><i className={preloader}></i></div>
                                </Col>
                                <Col md={7} align="right">
                                    <div className="btn-group">
                                        <button className="btn btn-relleno-primary" onClick={() => {this.setState({openWR: true})}} title= "Imprimir listado de aspirantes citados" style={{borderWidth: 1}}><i className="fa fa-print"></i> Imprimir</button>
                                        <button className="btn btn-relleno-danger" onClick = {this.verTodo()} style={{borderWidth: 1}} title = "Ver todos los aspirantes"><i className={btnFull.icon}></i> {btnFull.text}</button>
                                    </div>
                                </Col>
                            </Row>
                        </div>

                        <div className="custom-alert-info custom-mt-10">
                            Búsqueda de Estudiantes <i className={icon2}></i>
                            <input type="text" className="form-control" onKeyPress={this.busquedaEst()} value={strings} onChange={this.cambiaValor("strings")} placeholder="Ingresa la C.I., nombre o apellido del estudiante"/>
                        </div>
                
                        <div className="custom-alert-warning custom-mt-10" style={{padding: 5}}>
                            <div className="table-responsive" style={{backgroundColor:"#FFF", overflowX:"hidden", overflowY: "auto", maxHeight: 200}}>
                                <Table striped hover bordered>
                                    <tbody>
                                        <tr className="custon-back-color-warning">
                                            <td align="center" width="15%" style={styles}><strong>C.I.</strong></td>
                                            <td width="50%" style={styles}><strong>Aspirante</strong></td>
                                            <td align="center" width="35%" style={styles}><strong>Carrera</strong></td>
                                            <td align="center" width="100px" style={styles}><strong>Acciones</strong></td>
                                        </tr>
                                        {this.lisCitados()}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                        
                        <div className="custom-mt-10">
                            <div className="text-danger" align="center"><i className={string.icon}></i> {string.text}</div>
                            {this.contenido()}
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Consignación de Documentos</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modalFecha()}
                {this.modalNoAccept()}
                {this.modalAccept()}
                {this.modalPago()}
                {this.modalReporte()}
            </div>
        );
    }
}
 
export default Consignacion;


// WEBPACK FOOTER //
// ./src/views/AdmisionAdmin/AdmisionAdminContent/Consignacion.jsx